import { client } from '@mb/api/client';
import { endpoints } from '@mb/api/endpoints';
import type { Event } from '@mb/types';
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  setEventsList,
  setErrorMessage,
  setLoaded,
} from '../redux/events/eventsSlice';

export interface GetEventsResponse {
  status: string;
  events: Event[] | undefined;
  message: string | undefined;
}

export const getEventsAll = createAsyncThunk(
  'events/event/getall',
  // @ts-expect-error // TODO: fix types
  async (_, thunkApi) => {
    try {
      const {
        data: { status, events, message },
      } = await client.get<GetEventsResponse>(endpoints.eventsGetAll);

      if (status === 'failed') {
        thunkApi.dispatch(setErrorMessage(message));
      }

      if (Array.isArray(events)) {
        thunkApi.dispatch(setEventsList(events));
      }

      thunkApi.dispatch(setLoaded(true));
      return {
        events,
      };
    } catch (e) {
      thunkApi.dispatch(setLoaded(true));
      console.log('Error getEventsAll:', e);
    }
  },
);
